import React, { useEffect } from 'react';
import Layout from '../../Layout';
import ListWithHeadings from '../../components/MenuList';
import { MenuSelect } from "../../components/Form";
// import { settingsData } from '../../components/Datas';
import {
	TbChartHistogram,
} from "react-icons/tb";
import {
	RiImageLine,
	RiLockPasswordLine,
	RiMedicineBottleLine,
	RiMoneyDollarCircleLine,
} from "react-icons/ri";
import {
	MdOutlineInventory2,
	MdSwapHoriz
} from "react-icons/md";
import { AiOutlinePlusCircle, AiOutlineSetting, AiOutlineTeam } from "react-icons/ai";
import { BiCalendar, BiUserPlus } from "react-icons/bi";

import { useAppSelector } from '../../store';

function Settings() {
	const userData = useAppSelector((state) => state.userData);
	const data = [{ title: `Country` }];
	const [settingsData, setSettingsData] = React.useState([]);

	useEffect(() => {
		if (!userData?.user?.defaultLabId) {
			setSettingsData([
				{
					name: "Profile",
					data: [
						{ name: "Edit my profile", path: "/profile", icon: BiUserPlus },
						{ name: "Notifications", path: "/notifications", icon: RiLockPasswordLine }
					]
				},
				{
					name: "Other",
					data: [
						{ name: "Join existing lab", path: "/invitation", icon: AiOutlineTeam },
						{ name: "Create a new lab", path: "/new-lab", icon: AiOutlinePlusCircle },
						{ name: "Switch to another lab", path: "/switch-lab", icon: MdSwapHoriz }
					]
				}
			]);
		} else {
			setSettingsData([
				{
					name: "Profile",
					data: [
						{ name: "Edit my profile", path: "/profile", icon: BiUserPlus },
						{ name: "Notifications", path: "/notifications", icon: RiLockPasswordLine }
					]
				},
				{
					name: "My Lab",
					data: [
						{ name: "Edit lab settings", path: "/edit-lab", icon: AiOutlineSetting },
						{ name: "Subscription", path: "/subscriptions", icon: RiMoneyDollarCircleLine },
						{ name: "Tasks", path: "/tasks", icon: TbChartHistogram },
						{ name: "Scheduling templates", path: "/scheduling-tasks", icon: BiCalendar },
						{ name: "Products", path: "/products", icon: MdOutlineInventory2 },
						{ name: "Product Extras", path: "/extras", icon: RiImageLine },
						{ name: "Materials", path: "/materials", icon: RiMedicineBottleLine }
					]
				},
				{
					name: "Other",
					data: [
						{ name: "Join existing lab", path: "/invitation", icon: AiOutlineTeam },
						{ name: "Create a new lab", path: "/new-lab", icon: AiOutlinePlusCircle },
						{ name: "Switch to another lab", path: "/switch-lab", icon: MdSwapHoriz }
					]
				}
			]);
		}
	}, [userData]);

	return (
		<Layout>
			<h1 className="text-xl px-4 font-semibold">Settings</h1>
			<div className="grid grid-cols-12 gap-6 my-8 items-start">
				<ListWithHeadings listData={settingsData} />
				<MenuSelect className={"grid col-span-12 w-full mb-2 ml-4"} datas={data}>
					<div className="flex flex-1 flex-col">
						{/* <div className="flex flex-1 w-full">Select Language</div>
						<div className="flex flex-1 justify-between">
							<span>{`ml `}</span>
						</div> */}
					</div>
				</MenuSelect>
			</div>
		</Layout>
	);
}

export default Settings;
